import React from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';

import { PatternGridProps, SupportedTileSize } from './PatternGrid';
import styles from './PatternGrid.module.scss';

const ghostsFiller = new Array(18).fill(null);

export default function PatternGridGhost({
  pattern = ['small'],
}: Pick<PatternGridProps, 'pattern'>) {
  return (
    <div className={styles.layout}>
      {ghostsFiller.map((_, index) => {
        const tileSize: SupportedTileSize =
          index < pattern.length ? pattern[index] : 'small';

        return tileSize === 'small' ? (
          <GhostTile key={index} />
        ) : (
          <div
            className={
              tileSize === 'tall-vertical' ? styles.vertical : styles.horizontal
            }
            key={index}
          >
            <GhostTile />
          </div>
        );
      })}
    </div>
  );
}
